/** Internal helper imports here ... */
import Glide from "@glidejs/glide";

const Slider = (() => {
  const createSlider = (slider, index, sliderClass, options) => {
    const glide = new Glide(sliderClass, options).mount();

    slider[0].querySelectorAll(".glide__arrow").forEach((node) => {
      node.addEventListener("click", () => {
        glide.go(node.attributes["data-glide-dir"].value);
      });
    });
  };

  const init = () => {
    const testimonialsSlider = document.querySelectorAll(".testimonials");
    const latestBlogSlider = document.querySelectorAll(".latest-blog");
    const latestCandidatesSlider =
      document.querySelectorAll(".latest-candidates");
    const latestJobsSlider = document.querySelectorAll(".latest-jobs");

    if (testimonialsSlider.length) {
      Array(testimonialsSlider).forEach((slider, index) => {
        createSlider(slider, index, ".glide-testimonials", {
          type: "carousel",
          startAt: 0,
          gap: 0,
          perView: 1,
          rewind: true,
        });
      });
    }

    if (latestBlogSlider.length) {
      Array(latestBlogSlider).forEach((slider, index) => {
        createSlider(slider, index, ".glide-latest-blog", {
          type: "carousel",
          startAt: 0,
          gap: 30,
          perView: 4,
          rewind: true,
          breakpoints: {
            1200: {
              perView: 3,
            },
            991: {
              perView: 2,
            },
            // 420: {
            //   perView: 1,
            // },
          },
        });
      });
    }

    if (latestCandidatesSlider.length) {
      Array(latestCandidatesSlider).forEach((slider, index) => {
        createSlider(slider, index, ".glide-candidates", {
          type: "carousel",
          startAt: 0,
          gap: 30,
          perView: 3,
          rewind: true,
          breakpoints: {
            1000: {
              perView: 2,
            },
            580: {
              perView: 1,
            },
          },
        });
      });
    }

    if (latestJobsSlider.length) {
      Array(latestJobsSlider).forEach((slider, index) => {
        createSlider(slider, index, ".glide-jobs", {
          type: "carousel",
          startAt: 0,
          gap: 30,
          perView: 3,
          rewind: true,
          breakpoints: {
            1000: {
              perView: 2,
            },
            580: {
              perView: 1,
            },
          },
        });
      });
    }
  };

  return { init };
})();

export default Slider;
